'use strict';

(function() {
  /**
   * Service pour la gestion des actualités
   */
  
  angular
    .module('observatoireApp')
    .service('ActualitesService', ['$http', '$q', function($http, $q) {
      
      // Configuration de l'API
      var API_URL = '/api/actualites';
      
      /**
       * Récupère toutes les actualités
       * @returns {Promise} Une promesse qui résout vers la liste des actualités
       */
      this.getAllActualites = function() {
        console.log('Appel API - getAllActualites vers:', API_URL);
        return $http.get(API_URL, {
            params: {
              page: 0,
              size: 100 // Récupérer un grand nombre d'actualités pour l'affichage initial
            }
          })
          .then(function(response) {
            console.log('Réponse API - getAllActualites:', response);
            // Vérifier la structure de la réponse et adapter l'extraction des données
            var actualites = [];
            
            if (response.data && response.data.content && Array.isArray(response.data.content)) {
              // Format paginé
              actualites = response.data.content;
              console.log('Format paginé détecté');
            } else if (Array.isArray(response.data)) {
              // Format tableau
              actualites = response.data;
              console.log('Format tableau détecté');
            } else if (typeof response.data === 'object') {
              // Format objet unique
              actualites = [response.data];
              console.log('Format objet unique détecté');
            }
            
            // Transformer les données pour qu'elles correspondent au format attendu par le frontend
            return actualites.map(function(item) {
              // Débogage des données brutes
              console.log('Données brutes de l\'item:', item);
              console.log('Catégories dans l\'item:', item.categories);
              
              return {
                id: item.id,
                title: item.title || item.titre,
                summary: item.summary || item.resume,
                content: item.content || item.contenu,
                image: item.image || item.imageUrl || 'assets/images/placeholder.jpg',
                // Conserver la liste complète des catégories
                categories: item.categories,
                date: (function() {
                  // Vérifier d'abord si publishedAt est un tableau (cas spécial de LocalDateTime java)
                  if (item.publishedAt && Array.isArray(item.publishedAt) && item.publishedAt.length >= 3) {
                    var year = item.publishedAt[0];
                    var month = item.publishedAt[1] - 1; // Les mois en JS commencent à 0
                    var day = item.publishedAt[2];
                    return new Date(year, month, day).toISOString();
                  }
                  
                  // Traiter les valeurs possibles pour la date en priorisant published_at
                  var dateValue = item.published_at || item.publishedAt || item.date || item.createdAt;
                  
                  // Vérifier si la date est valide
                  if (dateValue) {
                    // Pour un format numérique, on le convertit en date
                    if (typeof dateValue === 'number') {
                      return new Date(dateValue).toISOString();
                    }
                    // Traiter les chaînes de date
                    if (typeof dateValue === 'string') {
                      // Vérifier si c'est une date ISO valide
                      var date = new Date(dateValue);
                      if (!isNaN(date.getTime())) {
                        return date.toISOString();
                      }
                      // Tenter de parser manuellement pour les formats non standards
                      var match = dateValue.match(/(\d{4})[-\/](\d{1,2})[-\/](\d{1,2})/);
                      if (match) {
                        return new Date(match[1], match[2] - 1, match[3]).toISOString();
                      }
                    }
                  }
                  
                  // Valeur par défaut si la date est invalide
                  return new Date().toISOString();
                })(),
                authorDisplay: (function() {
                  // Formatter l'auteur pour n'afficher que le prénom et le nom
                  if (item.author && typeof item.author === 'object') {
                    if (item.author.firstName && item.author.lastName) {
                      return item.author.firstName + ' ' + item.author.lastName;
                    } else if (item.author.firstname && item.author.lastname) {
                      return item.author.firstname + ' ' + item.author.lastname;
                    } else if (item.author.name) {
                      return item.author.name;
                    } else if (item.author.username) {
                      return item.author.username;
                    }
                  }
                  if (item.auteur && typeof item.auteur === 'object') {
                    if (item.auteur.firstName && item.auteur.lastName) {
                      return item.auteur.firstName + ' ' + item.auteur.lastName;
                    } else if (item.auteur.firstname && item.auteur.lastname) {
                      return item.auteur.firstname + ' ' + item.auteur.lastname;
                    } else if (item.auteur.name) {
                      return item.auteur.name;
                    } else if (item.auteur.username) {
                      return item.auteur.username;
                    }
                  }
                  // Si l'auteur est une chaîne de caractères
                  if (typeof item.author === 'string') {
                    return item.author;
                  }
                  if (typeof item.auteur === 'string') {
                    return item.auteur;
                  }
                  
                  return 'Admin';
                })(),
                // Compatibilité avec le nouveau format de catégorie (objet vs string)
                category: (function() {
                  console.log('Construction de la catégorie pour ID ' + item.id + ' avec categories:', item.categories);
                  
                  // 1. Vérifier d'abord si nous avons un tableau de catégories (format backend)
                  if (item.categories && Array.isArray(item.categories) && item.categories.length > 0) {
                    // Format des objets Category du backend
                    var firstCategory = item.categories[0];
                    console.log('Catégorie détectée dans le tableau categories:', firstCategory);
                    
                    // La catégorie pourrait être un objet ou une chaîne
                    if (typeof firstCategory === 'object' && firstCategory !== null) {
                      if (firstCategory.name) {
                        console.log('Nom de catégorie trouvé:', firstCategory.name);
                        return firstCategory.name;
                      } else if (firstCategory.nom) {
                        return firstCategory.nom;
                      } else {
                        // Autrement, tenter d'afficher une autre propriété disponible
                        console.log('Propriétés disponibles:', Object.keys(firstCategory));
                        return Object.keys(firstCategory).length > 0 ? firstCategory[Object.keys(firstCategory)[0]] : 'Général';
                      }
                    } else {
                      // La catégorie est une valeur simple (chaîne, nombre)
                      return String(firstCategory);
                    }
                  }
                  
                  // 2. Si aucun tableau categories n'est disponible, essayer la propriété category ou categorie
                  if (item.category) {
                    if (typeof item.category === 'object' && item.category !== null) {
                      return item.category.name || item.category.nom || 'Général';
                    } else {
                      return String(item.category);
                    }
                  }
                  
                  if (item.categorie) {
                    if (typeof item.categorie === 'object' && item.categorie !== null) {
                      return item.categorie.name || item.categorie.nom || 'Général';
                    } else {
                      return String(item.categorie);
                    }
                  }
                  
                  // 3. Si aucune catégorie n'est disponible
                  console.log('Aucune catégorie trouvée pour ID:', item.id);
                  return 'Général';
                })(),
                // Stocker l'ID de catégorie séparément pour la compatibilité avec le filtrage
                categoryId: item.category && item.category.id ? item.category.id : 
                           (item.categoryId || null),
                views: item.views || item.vues || 0,
                featured: item.featured || item.aLaUne || false
              };
            });
          })
          .catch(function(error) {
            console.error('Erreur lors de la récupération des actualités:', error);
            return $q.reject(error);
          });
      };
      
      /**
       * Récupère une actualité par son ID
       * @param {number} id - L'identifiant de l'actualité
       * @returns {Promise} Une promesse qui résout vers l'actualité correspondante
       */
      this.getActualiteById = function(id) {
        return $http.get(API_URL + '/' + id)
          .then(function(response) {
            // Afficher les données brutes pour débogage
            console.log('Données brutes de l\'actualité:', response.data);
            console.log('published_at:', response.data.publishedAt);
            console.log('Type de published_at:', typeof response.data.publishedAt);
            
            // Récupérer les données brutes
            var actualite = angular.copy(response.data);
            
            // S'assurer que les champs obligatoires sont présents avec des valeurs par défaut
            if (!actualite.title && actualite.titre) {
              actualite.title = actualite.titre;
            } else if (!actualite.title) {
              actualite.title = 'Sans titre';
            }
            
            if (!actualite.summary && actualite.resume) {
              actualite.summary = actualite.resume;
            } else if (!actualite.summary) {
              actualite.summary = 'Aucun résumé disponible.';
            }
            
            if (!actualite.content && actualite.contenu) {
              actualite.content = actualite.contenu;
            } else if (!actualite.content) {
              actualite.content = '<p>Aucun contenu disponible.</p>';
            }
            
            // S'assurer que l'image est définie
            if (!actualite.image && actualite.imageUrl) {
              actualite.image = actualite.imageUrl;
            } else if (!actualite.image) {
              actualite.image = 'assets/images/placeholder.jpg';
            }
            
            // S'assurer que les vues sont définies
            if (!actualite.views && actualite.vues) {
              actualite.views = actualite.vues;
            } else if (!actualite.views) {
              actualite.views = 0;
            }
            
            // S'assurer que la date est correctement définie en prioritisant published_at
            if (actualite.publishedAt) {
              console.log('publishedAt détecté:', actualite.publishedAt);
              
              // Si c'est un tableau (format spécial de LocalDateTime java)
              if (Array.isArray(actualite.publishedAt)) {
                var year = actualite.publishedAt[0];
                var month = actualite.publishedAt[1] - 1; // Les mois en JS commencent à 0
                var day = actualite.publishedAt[2];
                var date = new Date(year, month, day);
                actualite.date = date.toISOString();
                console.log('Date convertie depuis tableau:', actualite.date);
              } else {
                actualite.date = actualite.publishedAt;
              }
            } else if (actualite.published_at) {
              actualite.date = actualite.published_at;
            } else if (!actualite.date) {
              actualite.date = new Date().toISOString();
            }
            
            // Traiter les catégories
            if (actualite.categories && Array.isArray(actualite.categories) && actualite.categories.length > 0) {
              // Format des objets Category du backend
              var firstCategory = actualite.categories[0];
              console.log('Première catégorie détectée:', firstCategory);
              
              // La catégorie pourrait être un objet ou une chaîne
              if (typeof firstCategory === 'object' && firstCategory !== null) {
                if (firstCategory.name) {
                  actualite.category = firstCategory.name;
                } else if (firstCategory.nom) {
                  actualite.category = firstCategory.nom;
                } else {
                  actualite.category = 'Général';
                }
              } else {
                // La catégorie est une valeur simple (chaîne, nombre)
                actualite.category = String(firstCategory);
              }
            } else if (actualite.category) {
              if (typeof actualite.category === 'object' && actualite.category !== null) {
                actualite.category = actualite.category.name || actualite.category.nom || 'Général';
              }
              // Si c'est déjà une chaîne, on la laisse telle quelle
            } else {
              actualite.category = 'Général';
            }
            
            // Formatter l'auteur pour n'afficher que le prénom et le nom
            if (actualite.author && typeof actualite.author === 'object') {
              if (actualite.author.firstName && actualite.author.lastName) {
                actualite.authorDisplay = actualite.author.firstName + ' ' + actualite.author.lastName;
              } else if (actualite.author.firstname && actualite.author.lastname) {
                actualite.authorDisplay = actualite.author.firstname + ' ' + actualite.author.lastname;
              } else if (actualite.author.name) {
                actualite.authorDisplay = actualite.author.name;
              } else if (actualite.author.username) {
                actualite.authorDisplay = actualite.author.username;
              } else {
                actualite.authorDisplay = 'Admin';
              }
            } else if (actualite.auteur && typeof actualite.auteur === 'object') {
              if (actualite.auteur.firstName && actualite.auteur.lastName) {
                actualite.authorDisplay = actualite.auteur.firstName + ' ' + actualite.auteur.lastName;
              } else if (actualite.auteur.firstname && actualite.auteur.lastname) {
                actualite.authorDisplay = actualite.auteur.firstname + ' ' + actualite.auteur.lastname;
              } else if (actualite.auteur.name) {
                actualite.authorDisplay = actualite.auteur.name;
              } else if (actualite.auteur.username) {
                actualite.authorDisplay = actualite.auteur.username;
              } else {
                actualite.authorDisplay = 'Admin';
              }
            } else if (typeof actualite.author === 'string') {
              actualite.authorDisplay = actualite.author;
            } else if (typeof actualite.auteur === 'string') {
              actualite.authorDisplay = actualite.auteur;
            } else {
              actualite.authorDisplay = 'Admin';
            }
            
            console.log('Actualité formatée pour le détail:', actualite);
            return actualite;
          })
          .catch(function(error) {
            console.error('Erreur lors de la récupération de l\'actualité:', error);
            return $q.reject(error);
          });
      };
      
      /**
       * Incrémente le compteur de vues d'une actualité
       * @param {number} id - L'ID de l'actualité à incrémenter
       * @returns {Promise} Une promesse qui résout vers le nouveau nombre de vues
       */
      this.incrementViews = function(id) {
        // Note: Le backend actuel ne semble pas avoir d'endpoint spécifique pour incrémenter les vues
        // Pour le moment, nous simulons cette fonctionnalité
        return $q.when({ views: 1 }); // Retourne une promesse résolue avec un objet factice
      };
      
      /**
       * Filtre les actualités par catégorie
       * @param {string} category - La catégorie à filtrer
       * @returns {Promise} Une promesse qui résout vers la liste des actualités filtrées
       */
      this.getActualitesByCategory = function(category) {
        // L'API attend un ID de catégorie, mais notre frontend utilise un identifiant textuel
        // Pour le moment, nous filtrons côté client, mais idéalement il faudrait convertir les
        // identifiants de catégorie en ID numériques pour utiliser l'endpoint approprié
        return this.getAllActualites()
          .then(function(actualites) {
            return actualites.filter(function(act) {
              return act.category === category;
            });
          });
      };
      
      /**
       * Récupère les actualités à la une
       * @returns {Promise} Une promesse qui résout vers la liste des actualités à la une
       */
      this.getFeaturedActualites = function() {
        // Note: Cette fonction n'a pas d'équivalent direct dans l'API - une approche serait de
        // filtrer du côté client les actualités marquées comme mises en avant
        return this.getAllActualites()
          .then(function(actualites) {
            return actualites.filter(function(actualite) {
              return actualite.featured === true;
            }).slice(0, 5); // Limiter à 5 actualités mises en avant
          })
          .catch(function(error) {
            console.error('Erreur lors de la récupération des actualités à la une:', error);
            return $q.reject(error);
          });
      };
      
      /**
       * Récupère les actualités les plus vues
       * @param {number} limit - Le nombre d'actualités à récupérer
       * @returns {Promise} Une promesse qui résout vers la liste des actualités les plus vues
       */
      this.getMostViewedActualites = function(limit) {
        limit = limit || 5;
        // Note: cette fonctionnalité nécessiterait un endpoint spécifique au backend
        // Pour l'instant, on récupère toutes les publications puis on trie côté client
        return this.getAllActualites()
          .then(function(actualites) {
            return actualites
              .sort(function(a, b) {
                return (b.views || 0) - (a.views || 0);
              })
              .slice(0, limit);
          });
      };
      
      /**
       * Récupère les actualités récentes
       * @param {number} limit - Le nombre d'actualités à récupérer
       * @returns {Promise} Une promesse qui résout vers la liste des actualités récentes
       */
      this.getRecentActualites = function(limit) {
        limit = limit || 5;
        
        // D'abord, essayer de récupérer toutes les actualités
        return this.getAllActualites()
          .then(function(actualites) {
            // Trier par date (du plus récent au plus ancien)
            return actualites
              .sort(function(a, b) {
                var dateA = new Date(a.date);
                var dateB = new Date(b.date);
                return dateB - dateA;
              })
              .slice(0, limit);
          })
          .catch(function(error) {
            console.error('Erreur lors de la récupération des actualités récentes:', error);
            // En cas d'erreur, appeler directement l'API avec des paramètres de tri
            return $http.get(API_URL, {
                params: { 
                  page: 0,
                  size: limit,
                  sortBy: 'publishedAt',
                  direction: 'DESC'
                }
              })
              .then(function(response) {
                if (response.data && response.data.content) {
                  return response.data.content;
                }
                return [];
              });
          });
      };
      
      /**
       * Récupère toutes les catégories d'actualités depuis la table actualite_categories
       * @returns {Promise} Une promesse qui résout vers la liste des catégories
       */
      this.getCategories = function() {
        console.log('Appel API - getCategories vers:', API_URL + '/categories');
        return $http.get(API_URL + '/categories')
          .then(function(response) {
            console.log('Réponse API - getCategories:', response);
            // Retourner le contenu de la réponse ou un tableau vide en cas d'erreur
            // L'API devrait retourner un tableau d'objets avec des propriétés id et name
            if (response.data && Array.isArray(response.data)) {
              return response.data;
            } else if (response.data && Array.isArray(response.data.content)) {
              return response.data.content;
            } else {
              console.warn('Structure de réponse inattendue pour les catégories:', response.data);
              return response.data || [];
            }
          })
          .catch(function(error) {
            console.error('Erreur lors de la récupération des catégories:', error);
            return $q.reject(error);
          });
      };
      
      /**
       * Recherche des actualités selon un texte de recherche
       * @param {string} query - Le texte de recherche
       * @param {number} page - Le numéro de page (début à 0)
       * @param {number} size - Le nombre d'éléments par page
       * @returns {Promise} Une promesse qui résout vers la liste des actualités correspondantes
       */
      this.searchActualites = function(query, page, size) {
        if (!query) {
          return this.getAllActualites();
        }
        
        page = page || 0;
        size = size || 10;
        
        console.log('Recherche d\'actualités avec le mot-clé:', query);
        
        return $http.get(API_URL + '/search', {
            params: {
              keyword: query, // Le paramètre s'appelle 'keyword' dans l'API
              page: page,
              size: size
            }
          })
          .then(function(response) {
            console.log('Réponse brute de searchActualites:', response);
            
            // Vérifier la structure de la réponse et extraire les données
            var actualites = [];
            
            if (response.data && response.data.content && Array.isArray(response.data.content)) {
              // Format paginé (cas normal du backend Spring)
              actualites = response.data.content;
              console.log('Format paginé détecté, nombre d\'actualités trouvées:', actualites.length);
            } else if (Array.isArray(response.data)) {
              // Format tableau simple
              actualites = response.data;
              console.log('Format tableau simple détecté, nombre d\'actualités trouvées:', actualites.length);
            } else if (typeof response.data === 'object') {
              // Format objet unique (non attendu pour une recherche)
              actualites = [response.data];
              console.log('Format objet unique détecté');
            }
            
            // Transformer les données pour qu'elles correspondent au format attendu par le frontend
            return actualites.map(function(item) {
              return {
                id: item.id,
                title: item.title || item.titre,
                summary: item.summary || item.resume,
                content: item.content || item.contenu,
                image: item.image || item.imageUrl || 'assets/images/placeholder.jpg',
                categories: item.categories,
                date: (function() {
                  // Vérifier d'abord si publishedAt est un tableau (cas spécial de LocalDateTime java)
                  if (item.publishedAt && Array.isArray(item.publishedAt) && item.publishedAt.length >= 3) {
                    var year = item.publishedAt[0];
                    var month = item.publishedAt[1] - 1; // Les mois en JS commencent à 0
                    var day = item.publishedAt[2];
                    return new Date(year, month, day).toISOString();
                  }
                  
                  // Traiter les valeurs possibles pour la date en priorisant published_at
                  var dateValue = item.published_at || item.publishedAt || item.date || item.createdAt;
                  
                  if (dateValue) {
                    if (typeof dateValue === 'number') {
                      return new Date(dateValue).toISOString();
                    }
                    if (typeof dateValue === 'string') {
                      var date = new Date(dateValue);
                      if (!isNaN(date.getTime())) {
                        return date.toISOString();
                      }
                    }
                  }
                  
                  return new Date().toISOString();
                })(),
                authorDisplay: (function() {
                  // Formatter l'auteur pour n'afficher que le prénom et le nom
                  if (item.author && typeof item.author === 'object') {
                    if (item.author.firstName && item.author.lastName) {
                      return item.author.firstName + ' ' + item.author.lastName;
                    } else if (item.author.firstname && item.author.lastname) {
                      return item.author.firstname + ' ' + item.author.lastname;
                    } else if (item.author.name) {
                      return item.author.name;
                    } else if (item.author.username) {
                      return item.author.username;
                    }
                  }
                  if (typeof item.author === 'string') {
                    return item.author;
                  }
                  if (typeof item.auteur === 'string') {
                    return item.auteur;
                  }
                  
                  return 'Admin';
                })(),
                category: (function() {
                  if (item.categories && Array.isArray(item.categories) && item.categories.length > 0) {
                    var firstCategory = item.categories[0];
                    if (typeof firstCategory === 'object' && firstCategory !== null) {
                      return firstCategory.name || firstCategory.nom || 'Général';
                    }
                    return String(firstCategory);
                  }
                  if (item.category) {
                    if (typeof item.category === 'object' && item.category !== null) {
                      return item.category.name || item.category.nom || 'Général';
                    } 
                    return String(item.category);
                  }
                  return 'Général';
                })(),
                categoryId: item.category && item.category.id ? item.category.id : (item.categoryId || null),
                views: item.views || item.vues || 0,
                featured: item.featured || item.aLaUne || false
              };
            });
          })
          .catch(function(error) {
            console.error('Erreur lors de la recherche d\'actualités:', error);
            return $q.reject(error);
          });
      };
    }]);
})();
